import TabDocuments from './TabDocuments';

export default TabDocuments;
